export const apiUrl = "https://dev.api.utilstop.com/";
// export const apiUrl = "https://api.utilstop.com/";
export const admin_role_id = 1;
export const support_user_role = 2;
// export const apiUrl = "http://localhost:3007/";

export const pub_nub_publishKey = "pub-c-9020aa61-fd49-42aa-888e-da5f47448738";
export const google_distance_key = "AIzaSyCaaDIVpT9tFcIJTxUZICFEcdm-K5-TUps";
export const google_places_key = "AIzaSyAatqW_QBs26_bOCVlVBBxFRy3L7dPkiEU";
export const google_translation_key = "AIzaSyBtV3gN146IxIzPpq17ohI9ITIswKPlA2E";

export const pub_nub_subscribeKey =
  "sub-c-e81838e0-9a1a-4c04-9c3f-52f953fc417f";
export const pub_nub_uuid = "us_admin";
